/* global customerAddress invalidAddress invoiceFormHasServerErrors */

import { logError } from '../services/sentryService';

const INVOICE = {};
const INVOICE_FORM_FIELD_PREFIX = 'billingAddress.customerAddress';
INVOICE.init = function () {
  initInvoiceAddressForm();
};

const handleInvoiceAddressFormData = (callbackData) => {
  const { action } = callbackData;
  if (action === 'CANCEL') {
    window.location.href = '/checkout/preview';
  }
};

const initInvoiceAddressForm = () => {
  if (typeof window.InvoiceAddressForm !== 'object') {
    logError('InvoiceAddressForm JS is not properly loaded.');
    return;
  }

  const invoiceAddressFormParams = getInvoiceAddressFormParams();
  if (invoiceFormHasServerErrors) {
    invoiceAddressFormParams['error'] = {
      hasServerError: true,
      hasValidationError: invalidAddress,
    };
  }

  window.InvoiceAddressForm.render(invoiceAddressFormParams);
};

const getInvoiceAddressFormParams = () => {
  const formSubmitUrl = '/checkout/editaddress';
  const { birthDate = '', birthMonth = '', birthYear = '' } = customerAddress;
  const customerBirthDate =
    birthDate && birthMonth && birthYear
      ? `${birthMonth}/${birthDate}/${birthYear}`
      : '';
  return {
    elementId: 'invoice-address-form-container',
    hiddenFields: {
      'X-CSRF-Token': window.csrfToken,
    },
    birthDateHiddenFields: {
      'billingAddress.dateOfBirth.birthDate': 'birthDate',
      'billingAddress.dateOfBirth.birthMonth': 'birthMonth',
      'billingAddress.dateOfBirth.birthYear': 'birthYear',
    },
    formAttributes: {
      action: formSubmitUrl,
      fieldNamePrefix: INVOICE_FORM_FIELD_PREFIX,
      showBirthDateField: 'true',
      consumerName: 'orderPreview',
    },
    defaultValues: {
      id: customerAddress.addressId,
      firstName: customerAddress.addressFirstName,
      lastName: customerAddress.addressLastName,
      street: customerAddress.addressStreet,
      city: customerAddress.addressCity,
      postalCode: customerAddress.addressPostalCode,
      countryShortName: customerAddress.countryShortName,
      phoneNumber: customerAddress.addressPhoneNumber,
      additionalInformation: customerAddress.addressCompany,
      birthDate: customerBirthDate,
      taxId: customerAddress.taxId,
    },
    callback: handleInvoiceAddressFormData,
  };
};
export default INVOICE;
